import { LIST_NAVIGATIONS_QUERY } from './schema';

export async function listNavigations(client, options = {}) {
  const response = await client.query({
    query: LIST_NAVIGATIONS_QUERY,
    ...options,
  });

  return {
    data: response.data?.listNavigations,
    error: response.error,
  };
}
